import toast, { Toaster } from "react-hot-toast";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import ServicesBGS from "./pages/ServicesBGS";
import ServicesSTS from "./pages/ServicesSTS";
import ServicesWSM from "./pages/ServicesWSM";
import ContactUs from "./pages/ContactUs";
import Portfolio from "./pages/Portfolio";
import WebServices from "./pages/WebServices";
import { useEffect } from "react";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    let hasShownToast = false;

    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();

      if (!hasShownToast) {
        toast.error("Right click is disabled 🚫");
        hasShownToast = true;

        setTimeout(() => {
          hasShownToast = false;
        }, 4000); // reset after 4s
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
    };

    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/brandgrowthsolution" element={<ServicesBGS />} />
            <Route path="/smarttechsolution" element={<ServicesSTS />} />
            <Route path="/whatsappsmsmarketing" element={<ServicesWSM />} />
            <Route path="/web-services" element={<WebServices />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/portfolio/*" element={<Portfolio />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#f5f5f5",
              color: "#0d1821",
              fontFamily: "Poppins",
            },
          }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
